
const state = {
  username: localStorage.getItem('username'),
  password: '',
  email: localStorage.getItem('email'),
  resetPasswordJWT: undefined,
  token: localStorage.getItem('token'),
  remember: localStorage.getItem('remember') === 'true',
  locale: localStorage.getItem('locale'),
  userId: localStorage.getItem('userId'),
  admin: localStorage.getItem('admin') === 'true',
  logo: localStorage.getItem('logo'),
  loginLogo: localStorage.getItem('loginLogo'),
  loginBackgroundImage: localStorage.getItem('loginBackgroundImage'),
  themes: JSON.parse(localStorage.getItem('themes')),
  privileges: [],
  enterpriseId: localStorage.getItem('enterpriseId'),
}

// getters
const getters = {
  getUserId: (state) => {
    return state.userId
  },
  getUsername: (state) => {
    return state.username
  },
  getPassword: (state) => {
    return state.password
  },
  getEmail: (state) => {
    return state.email
  },
  getResetPasswordJWT: (state) => {
    return state.resetPasswordJWT
  },
  getRemember: (state) => {
    return state.remember
  },
  getLocale: (state) => {
    return state.locale
  },
  getLogo: (state) => {
    return state.logo
  },
  getLoginLogo: (state) => {
    return state.loginLogo
  },
  getLoginBackgroundImage: (state) => {
    return state.loginBackgroundImage
  },
  getThemes: (state) => {
    return state.themes
  },
  getToken: () => {
    return state.token || localStorage.getItem('token')
  },
  getPrivileges: state => {
    return (state.privileges.length > 0 && state.privileges) || JSON.parse(localStorage.getItem('privileges'))
  },
  getAdmin: state => {
    return state.admin || JSON.parse(localStorage.getItem('admin'))
  },
  getEnterpriseId: () => {
    return state.enterpriseId
  }
}

// actions
const actions = {
  clearSessionData ({ commit }) {
    commit('commitUserId', { userId: '' })
    commit('commitPassword', { password: '' })
    commit('commitResetPasswordJWT', { resetPasswordJWT: undefined })
    commit('commitToken', { token: undefined })
    commit('commitAdmin', { admin: false })
    commit('commitEmail', { email: '' })
    commit('commitPrivileges', { privileges: [] })

    localStorage.removeItem('email')
    localStorage.removeItem('userConfiguration')
    localStorage.removeItem('userId')
    localStorage.removeItem('token')
    localStorage.removeItem('admin')
    localStorage.removeItem('privileges')
  },
  setUserId ({ commit }, userId) {
    localStorage.setItem('userId', userId)
    commit('commitUserId', { userId })
  },
  setUsername ({ commit }, username) {
    localStorage.setItem('username', username)
    commit('commitUsername', { username })
  },
  setPassword ({ commit }, password) {
    commit('commitPassword', { password })
  },
  setEmail ({ commit }, email) {
    localStorage.setItem('email', email)
    commit('commitEmail', { email })
  },
  setResetPasswordJWT ({ commit }, resetPasswordJWT) {
    commit('commitResetPasswordJWT', { resetPasswordJWT })
  },
  setRemember ({ commit }, remember) {
    localStorage.setItem('remember', remember)
    commit('commitRemember', { remember })
  },
  setLocale ({ commit }, locale) {
    localStorage.setItem('locale', locale)
    commit('commitLocale', { locale })
  },
  setLogo ({ commit }, logo) {
    if (logo) {
      localStorage.setItem('logo', logo)
    } else {
      localStorage.removeItem('logo')
    }
    commit('commitLogo', { logo })
  },
  setLoginLogo ({ commit }, loginLogo) {
    if (loginLogo) {
      localStorage.setItem('loginLogo', loginLogo)
    } else {
      localStorage.removeItem('loginLogo')
    }
    commit('commitLoginLogo', { loginLogo })
  },
  setLoginBackgroundImage ({ commit }, loginBackgroundImage) {
    if (loginBackgroundImage) {
      localStorage.setItem('loginBackgroundImage', loginBackgroundImage)
    } else {
      localStorage.removeItem('loginBackgroundImage')
    }
    commit('commitLoginBackgroundImage', { loginBackgroundImage })
  },
  setThemes ({ commit }, themes) {
    if (themes) {
      localStorage.setItem('themes', JSON.stringify(themes))
    } else {
      localStorage.removeItem('themes')
    }
    commit('commitThemes', { themes })
  },
  setPrivileges ({ commit }, privileges) {
    localStorage.setItem('privileges', JSON.stringify(privileges))
    commit('commitPrivileges', { privileges })
  },
  setAdmin ({ commit }, admin) {
    localStorage.setItem('admin', admin)
    commit('commitAdmin', { admin })
  },
  setToken ({ commit }, token) {
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
    commit('commitToken', { token })
  },
  setEnterpriseId ({ commit }, enterpriseId) {
    if (enterpriseId) {
      localStorage.setItem('enterpriseId', enterpriseId)
    } else {
      localStorage.removeItem('enterpriseId')
    }
    commit('commitEnterpriseId', { enterpriseId })
  }
}

// mutations
const mutations = {
  commitUserId (state, { userId }) {
    state.userId = userId
  },
  commitUsername (state, { username }) {
    state.username = username
  },
  commitPassword (state, { password }) {
    state.password = password
  },
  commitEmail (state, { email }) {
    state.email = email
  },
  commitResetPasswordJWT (state, { resetPasswordJWT }) {
    state.resetPasswordJWT = resetPasswordJWT
  },
  commitRemember (state, { remember }) {
    state.remember = remember
  },
  commitLocale (state, { locale }) {
    state.locale = locale
  },
  commitLogo (state, { logo }) {
    state.logo = logo
  },
  commitLoginLogo (state, { loginLogo }) {
    state.loginLogo = loginLogo
  },
  commitLoginBackgroundImage (state, { loginBackgroundImage }) {
    state.loginBackgroundImage = loginBackgroundImage
  },
  commitThemes (state, { themes }) {
    state.themes = themes
  },
  commitToken (state, { token }) {
    state.token = token
  },
  commitPrivileges (state, { privileges }) {
    state.privileges = privileges
  },
  commitAdmin (state, { admin }) {
    state.admin = admin
  },
  commitEnterpriseId (state, { enterpriseId }) {
    state.enterpriseId = enterpriseId
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
